export default __webpack_public_path__ + "static/media/icon_expired.57ad010c.png";